module.exports = __webpack_public_path__ + "assets/sprites_emoji_32-60f901a0563fb9825a4f9a4f.png";